var map = {
	"./BOOST.svg": 2397,
	"./GRAB.svg": 2398,
	"./MBB.svg": 2399,
	"./TNG.svg": 2400,
	"./direpay.svg": 2401,
	"./doitnow.svg": 2402,
	"./duitnow.svg": 2403,
	"./fpay.svg": 2404,
	"./fpay2.svg": 2405,
	"./fpx.svg": 2406,
	"./online_banking.svg": 2407,
	"./rapidpays.svg": 2408,
	"./secret_pay.svg": 2409,
	"./secret_pay_offline.svg": 2410,
	"./secret_pay_pro.svg": 2411,
	"./secret_pay_pro_b.svg": 2412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;